import { render, staticRenderFns } from "./PlantLogoBanner.vue?vue&type=template&id=13211808&scoped=true&"
import script from "./PlantLogoBanner.vue?vue&type=script&lang=js&"
export * from "./PlantLogoBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlantLogoBanner.vue?vue&type=style&index=0&id=13211808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13211808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
